<template>
    <div>
        <el-breadcrumb separator="/" style="height:20px;margin:10px 0;">
            <el-breadcrumb-item v-for="item in currentPath" :key="item.path">
                {{item.meta.title}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
export default {
    name: "Breadcrumb",
    data(){
        return {
            currentPath : null
        }
    },
    watch:{
        $route: {
            handler() {
                this.getBreadList()
            },
            deep: true,
            immediate: true
        }
    },
    methods:{
        getBreadList(){
            let matched = this.$route.matched.filter(item => item.name !== 'Layout')//$route.matched 将会是一个包含从上到下的所有对象 (副本)。
            this.currentPath = matched;
            this.currentPath.forEach(item => {
                if (this.$i18n.locale.indexOf('en') !== -1) {
                    item.meta.title = item.meta.enTitle;
                }else{
                    item.meta.title = item.meta.zhTitle;
                }
            });
        }
    }
}
</script>